const _temp0 = require("./01-PeopleCorporate.json");
const _temp1 = require("./02-PeopleCraft.json");
const _temp2 = require("./03-PeopleSports.json");
const _temp3 = require("./04-PeopleOutdoor.json");
const _temp4 = require("./05-PeopleFinancial.json");
const _temp5 = require("./06-PeopleCity.json");
const _temp6 = require("./07-PeopleFun.json");
const _temp7 = require("./08-PeopleDiverseHome.json");
const _temp8 = require("./09-PeopleDiverseCorporate.json");
const _temp9 = require("./12-PeopleDiverseCity.json");
const _temp10 = require("./13-Family.json");
const _temp11 = require("./14-FamilyHome.json");
const _temp12 = require("./15-HumanConnection.json");
const _temp13 = require("./16-HumanNatureMacro.json");
const _temp14 = require("./17-HumanAnimalMacro.json");
const _temp15 = require("./18-NatureWater.json");
const _temp16 = require("./19-NatureLandscape.json");
const _temp17 = require("./20-NatureMacro.json");
const _temp18 = require("./21-CityDaytime.json");
const _temp19 = require("./22-CityNighttime.json");
const _temp20 = require("./23-TechEveryday.json");
const _temp21 = require("./24-FinancialData.json");
const _temp22 = require("./25-AbstractBackgrounds.json");
const _temp23 = require("./26-AbstractNaturalLight.json");
module.exports = {
  "01-PeopleCorporate": _temp0,
  "02-PeopleCraft": _temp1,
  "03-PeopleSports": _temp2,
  "04-PeopleOutdoor": _temp3,
  "05-PeopleFinancial": _temp4,
  "06-PeopleCity": _temp5,
  "07-PeopleFun": _temp6,
  "08-PeopleDiverseHome": _temp7,
  "09-PeopleDiverseCorporate": _temp8,
  "12-PeopleDiverseCity": _temp9,
  "13-Family": _temp10,
  "14-FamilyHome": _temp11,
  "15-HumanConnection": _temp12,
  "16-HumanNatureMacro": _temp13,
  "17-HumanAnimalMacro": _temp14,
  "18-NatureWater": _temp15,
  "19-NatureLandscape": _temp16,
  "20-NatureMacro": _temp17,
  "21-CityDaytime": _temp18,
  "22-CityNighttime": _temp19,
  "23-TechEveryday": _temp20,
  "24-FinancialData": _temp21,
  "25-AbstractBackgrounds": _temp22,
  "26-AbstractNaturalLight": _temp23
}